import createField from '../../utils/factory/createField'
import {
  faUser,
  faTag,
  faIdCard,
  faHome,
  faPhoneAlt,
  faEnvelope,
  faAddressBook,
  faRoad,
  faMapPin,
  faBuilding,
  faCity,
  faGlobeAmericas,
  faGlobe,
  faMobileAlt,
  faAt,
} from '@fortawesome/free-solid-svg-icons'

export const supplierFields = [
  {
    section: 'Informações Gerais',
    fields: [
      createField({
        id: 'supplier.name',
        label: 'Razão Social',
        type: 'text',
        placeholder: 'Razão Social do fornecedor',
        fullWidth: true,
        icon: faAddressBook,
      }),
      createField({
        id: 'supplier.alias',
        label: 'Nome Fantasia',
        type: 'text',
        placeholder: 'Nome Fantasia do fornecedor',
        fullWidth: false,
        icon: faUser,
      }),
      createField({
        id: 'supplier.cpf_cnpj',
        label: 'CPF/CNPJ',
        type: 'text',
        placeholder: 'Documento do fornecedor',
        icon: faIdCard,
        mask: 'cpfCnpj',
      }),
      createField({
        id: 'supplier.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhoneAlt,
      }),
      createField({
        id: 'supplier.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail',
        required: false,
        icon: faEnvelope,
      }),
    ],
  },
]

export const createSupplierFields = [
  {
    section: 'Informações do Fornecedor',
    fields: [
      createField({
        id: 'supplier.alias',
        label: 'Nome Fantasia',
        type: 'text',
        placeholder: 'Digite o nome fantasia do fornecedor',
        required: true,
        icon: faTag,
      }),
      createField({
        id: 'supplier.name',
        label: 'Razão Social',
        type: 'text',
        placeholder: 'Digite a razão social do fornecedor',
        required: true,
        icon: faUser,
      }),
      createField({
        id: 'supplier.cpf_cnpj',
        label: 'CPF/CNPJ',
        type: 'text',
        placeholder: 'Digite o CPF ou CNPJ',
        required: true,
        icon: faIdCard,
        fullWidth: true,
        mask: 'cpfCnpj',
      }),
      createField({
        id: 'supplier.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhoneAlt,
        mask: 'phone',
      }),
      createField({
        id: 'supplier.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail',
        required: false,
        icon: faEnvelope,
      }),
    ],
  },
  {
    section: 'Endereço',
    fields: [
      createField({
        id: 'address.alias',
        label: 'Apelido do Endereço',
        type: 'text',
        placeholder: 'Digite o apelido do endereço',
        required: true,
        icon: faHome,
      }),
      createField({
        id: 'address.zip',
        label: 'CEP',
        type: 'text',
        placeholder: 'Digite o CEP',
        required: true,
        icon: faMapPin,
        mask: '99999-999',
      }),
      createField({
        id: 'address.street',
        label: 'Rua',
        type: 'text',
        placeholder: 'Digite a rua',
        required: true,
        icon: faRoad,
      }),
      createField({
        id: 'address.number',
        label: 'Número',
        type: 'text',
        placeholder: 'Digite o número',
        required: true,
        icon: faHome,
      }),
      createField({
        id: 'address.details',
        label: 'Complemento',
        type: 'text',
        placeholder: 'Digite detalhes adicionais',
        required: false,
        icon: faHome,
      }),
      createField({
        id: 'address.district',
        label: 'Bairro',
        type: 'text',
        placeholder: 'Digite o bairro',
        required: true,
        icon: faBuilding,
      }),
      createField({
        id: 'address.city',
        label: 'Cidade',
        type: 'text',
        placeholder: 'Digite a cidade',
        required: true,
        icon: faCity,
        fullWidth: true,
      }),
      createField({
        id: 'address.state',
        label: 'Estado',
        type: 'text',
        placeholder: 'Digite o estado',
        required: true,
        icon: faGlobeAmericas,
      }),
      createField({
        id: 'address.country',
        label: 'País',
        type: 'text',
        placeholder: 'Digite o país',
        required: true,
        icon: faGlobe,
      }),
    ],
  },
  {
    section: 'Contato',
    fields: [
      createField({
        id: 'contact.name',
        label: 'Nome do Contato',
        type: 'text',
        placeholder: 'Digite o nome do contato',
        required: true,
        icon: faUser,
      }),
      createField({
        id: 'contact.surname',
        label: 'Sobrenome',
        type: 'text',
        placeholder: 'Digite o sobrenome do contato',
        required: false,
        icon: faUser,
      }),
      createField({
        id: 'contact.role',
        label: 'Cargo',
        type: 'text',
        placeholder: 'Digite o cargo',
        required: false,
        icon: faUser,
      }),
      createField({
        id: 'contact.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: true,
        mask: 'phone',
        icon: faPhoneAlt,
      }),
      createField({
        id: 'contact.cell',
        label: 'Celular',
        type: 'text',
        placeholder: 'Digite o número do celular',
        required: false,
        icon: faMobileAlt,
        mask: 'phone',
      }),
      createField({
        id: 'contact.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail do contato',
        required: true,
        icon: faEnvelope,
      }),
    ],
  },
]

export const detailsSupplierFields = [
  {
    section: 'Informações Gerais',
    fields: [
      createField({
        id: 'name',
        label: 'Razão Social',
        type: 'text',
        placeholder: 'Razão Social do fornecedor',
        fullWidth: true,
        icon: faAddressBook,
        disabled: true,
      }),
      createField({
        id: 'alias',
        label: 'Nome Fantasia',
        type: 'text',
        placeholder: 'Nome Fantasia do fornecedor',
        fullWidth: false,
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'cpf_cnpj',
        label: 'CPF/CNPJ',
        type: 'text',
        placeholder: 'Documento do fornecedor',
        icon: faIdCard,
        mask: 'cpfCnpj',
        disabled: true,
      }),
      createField({
        id: 'supplier.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhoneAlt,
        mask: 'phone',
        disabled: true,
      }),
      createField({
        id: 'supplier.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail',
        required: false,
        icon: faEnvelope,
        disabled: true,
      }),
    ],
  },
]
